<template>
  <div class="view-detail-dialog">
    <el-dialog
      :title="(formData.action || 'view') === 'view' ? '查看雇主险订单详情':formData.action === 'add' ? '新增雇主险保单' : '修改雇主险保单'"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose">
      <el-form :model="formData" label-width="150px" v-loading="loading">
        <!-- 客户信息 -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="投保人：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.policyholder }}</span>
              <el-input v-else v-model="formData.policyholder" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="被保险人：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.beneficiary }}</span>
              <el-input v-else v-model="formData.beneficiary" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.mobile }}</span>
              <el-input v-else v-model="formData.mobile" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="渠道商：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatPolicyChannel(formData) }}</span>
              <!-- 修改为下拉选择支持模糊搜索，与平安干线保用户组件保持一致 -->
              <el-select 
                v-else 
                v-model="channelName"
                filterable 
                remote 
                reserve-keyword
                placeholder="请输入渠道商名称搜索"
                :remote-method="getChannelOptions" 
                :loading="loading" 
                @change="handleChannelChange">
                <el-option
                  v-for="item in channelOptions"
                  :key="item.id"
                  :label="item.realname ? item.realname + '(' + item.alias + ')' : item.alias"
                  :value="item.realname">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="省份：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.province }}</span>
              <!-- 修改为下拉选择支持模糊搜索 -->
              <el-select 
                v-else 
                v-model="formData.province" 
                filterable 
                remote 
                :remote-method="getProvinceOptions" 
                :loading="loading" 
                placeholder="请选择省份">
                <el-option
                  v-for="item in provinceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="城市：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.city }}</span>
              <!-- 修改为下拉选择支持模糊搜索 -->
              <el-select 
                v-else 
                v-model="formData.city" 
                filterable 
                remote 
                :remote-method="getCityOptions" 
                :loading="loading" 
                placeholder="请选择城市">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 投保人开票信息 -->
        <h3 style="text-align: center; margin: 15px 0;">投保人开票信息</h3>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="发票开具：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatVatInvoiceOpenType(formData.vat_invoice_open_type) }}</span>
              <el-select v-else v-model="formData.vat_invoice_open_type">
                <el-option label="开票" value="1"></el-option>
                <el-option label="不开票" value="2"></el-option>
                <el-option label="待定" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.vat_invoice_open_type == 1">
            <el-form-item label="开票类型：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatVatInvoiceTypeDetail(formData.vat_invoice_type) }}</span>
              <el-select v-else v-model="formData.vat_invoice_type">
                <el-option label="普票" value="1"></el-option>
                <el-option label="专票" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row v-if="formData.vat_invoice_open_type == 1 && formData.vat_invoice_type == 1">
          <el-col :span="12">
            <el-form-item label="开票抬头：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatVatInvoiceTitle(formData.vat_invoice_title) }}</span>
              <el-select v-else v-model="formData.vat_invoice_title">
                <el-option label="企业" value="1"></el-option>
                <el-option label="个人" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.vat_invoice_title == 2">
            <el-form-item label="个人名称：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.individual_title_name }}</span>
              <el-input v-else v-model="formData.individual_title_name" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row v-if="formData.vat_invoice_open_type == 1 && (formData.vat_invoice_title != 2 || !formData.vat_invoice_title)">
          <el-col :span="12">
            <el-form-item label="纳税人名称：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.tax_name }}</span>
              <el-input v-else v-model="formData.tax_name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税务登记号：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.tax_no }}</span>
              <el-input v-else v-model="formData.tax_no" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row v-if="formData.vat_invoice_open_type == 1 && formData.vat_invoice_type == 2">
          <el-col :span="12">
            <el-form-item label="税务登记地址：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.tax_address }}</span>
              <el-input v-else v-model="formData.tax_address" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税务登记联系电话：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.tax_mobile }}</span>
              <el-input v-else v-model="formData.tax_mobile" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row v-if="formData.vat_invoice_open_type == 1 && formData.vat_invoice_type == 2">
          <el-col :span="12">
            <el-form-item label="税务开户银行名称：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.tax_bank }}</span>
              <el-input v-else v-model="formData.tax_bank" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税务开户银行账号：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.tax_bank_no }}</span>
              <el-input v-else v-model="formData.tax_bank_no" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传投保人公司营业执照：">
              <div v-if="(formData.action || 'view') === 'view'">
                <div v-if="formData.license_file_url">
                  <img 
                    v-if="isImageFile(formData.license_file_url)" 
                    :src="formData.license_file_url" 
                    style="max-width: 200px; max-height: 200px;" 
                    alt="营业执照"
                  />
                  <a v-else :href="formData.license_file_url" target="_blank">查看文件</a>
                </div>
                <div v-else>未上传</div>
              </div>
              <div v-else>
                <!-- 修改为文件上传组件 -->
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="dynamicUploadHeaders"
                  :file-list="fileList.licenseFileList"
                  :on-success="handleLicenseFileSuccess"
                  :on-error="handleUploadError"
                  :on-remove="handleLicenseFileRemove"
                  :limit="1"
                  name="fileVal"
                  ref="licenseUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row v-if="formData.vat_invoice_open_type == 1 && formData.vat_invoice_type == 2">
          <el-col :span="12">
            <el-form-item label="上传一般纳税人证明：">
              <div v-if="(formData.action || 'view') === 'view'">
                <div v-if="formData.tax_file_url">
                  <img 
                    v-if="isImageFile(formData.tax_file_url)" 
                    :src="formData.tax_file_url" 
                    style="max-width: 200px; max-height: 200px;" 
                    alt="一般纳税人证明"
                  />
                  <a v-else :href="formData.tax_file_url" target="_blank">查看文件</a>
                </div>
                <div v-else>未上传</div>
              </div>
              <div v-else>
                <!-- 修改为文件上传组件 -->
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="dynamicUploadHeaders"
                  :file-list="fileList.taxFileList"
                  :on-success="handleTaxFileSuccess"
                  :on-error="handleUploadError"
                  :on-remove="handleTaxFileRemove"
                  :limit="1"
                  name="fileVal"
                  ref="taxUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上传开票信息采集表：">
              <div v-if="(formData.action || 'view') === 'view'">
                <div v-if="formData.vat_file_url">
                  <img 
                    v-if="isImageFile(formData.vat_file_url)" 
                    :src="formData.vat_file_url" 
                    style="max-width: 200px; max-height: 200px;" 
                    alt="开票信息采集表"
                  />
                  <a v-else :href="formData.vat_file_url" target="_blank">查看文件</a>
                </div>
                <div v-else>未上传</div>
              </div>
              <div v-else>
                <!-- 修改为文件上传组件 -->
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="dynamicUploadHeaders"
                  :file-list="fileList.vatFileList"
                  :on-success="handleVatFileSuccess"
                  :on-error="handleUploadError"
                  :on-remove="handleVatFileRemove"
                  :limit="1"
                  name="fileVal"
                  ref="vatUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 投保信息 -->
        <h3 style="text-align: center; margin: 15px 0;">投保信息</h3>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="保险公司：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatInsuranceType(formData.insurance_type) }}</span>
              <!-- 修改为下拉选择支持模糊搜索 -->
              <el-select 
                v-else 
                v-model="formData.insurance_type"
                filterable 
                remote
                reserve-keyword
                placeholder="请输入保险公司名称搜索"
                :remote-method="getInsuranceOptions"
                :loading="insuranceLoading"
                clearable
                style="width: 100%">
                <el-option
                  v-for="item in insuranceOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品类型：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.product_name }}</span>
              <!-- 修改为下拉选择支持模糊搜索 -->
              <el-select 
                v-else 
                v-model="formData.product_id"
                filterable 
                remote
                reserve-keyword
                placeholder="请输入产品类型名称搜索"
                :remote-method="getProductOptions"
                :loading="productLoading"
                clearable
                style="width: 100%"
                @change="handleProductChange">
                <el-option
                  v-for="item in productOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="搬运工人折扣单价：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatMoneyValue(formData.driver_price) }}</span>
              <el-input v-else v-model="formattedDriverPrice" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="搬运工人人数：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.driver_number }}</span>
              <el-input v-else v-model.number="formData.driver_number" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="文员内勤折扣单价：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatMoneyValue(formData.clerk_price) }}</span>
              <el-input v-else v-model="formattedClerkPrice" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文员内勤人数：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.clerk_number }}</span>
              <el-input v-else v-model.number="formData.clerk_number" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="司机押运折扣单价：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatMoneyValue(formData.trucker_price) }}</span>
              <el-input v-else v-model="formattedTruckerPrice" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机押运人数：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.trucker_number }}</span>
              <el-input v-else v-model.number="formData.trucker_number" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="录单应付保费：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatMoneyValue(formData.must_price) }}</span>
              <el-input v-else v-model="formattedMustPrice" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="录单实际保费：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatMoneyValue(formData.actual_price) }}</span>
              <el-input v-else v-model="formattedActualPrice" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="保单号：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formData.policy_no }}</span>
              <el-input v-else v-model="formData.policy_no" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结算渠道：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatSettlementChannel(null, null, formData.settlement_channel) }}</span>
              <el-select v-else v-model="formData.settlement_channel">
                <el-option label="恒丰经纪" value="1"></el-option>
                <el-option label="中际心元" value="2"></el-option>
                <el-option label="鼎盛" value="4"></el-option>
                <el-option label="现金结算" value="16"></el-option>
                <el-option label="北京丰融" value="32"></el-option>
                <el-option label="四川人保-物流保险网" value="17"></el-option>
                <el-option label="金联安" value="18"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="投保时间：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatDateValue(formData.created_at) }}</span>
              <el-date-picker
                v-else
                v-model="formData.created_at"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择投保时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效时间：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatDateValue(formData.effect_date) }}</span>
              <el-date-picker
                v-else
                v-model="formData.effect_date"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择生效时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="结束时间：">
              <span v-if="(formData.action || 'view') === 'view'">{{ formatDateValue(formData.expire_date) }}</span>
              <el-date-picker
                v-else
                v-model="formData.expire_date"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>
        
        <!-- 员工信息 -->
        <div class="employee-section-header">
          <h3 class="employee-section-title">
            {{ (formData.action || 'view') === 'view' ? `在保人员信息（${filteredEmployeeList.length}人）` : '员工信息' }}
          </h3>

          <div class="employee-excel-panel">
            <template v-if="(formData.action || 'view') === 'view'">
              <span class="employee-excel-label">员工信息文件：</span>
              <a v-if="formData.excel_file_url" :href="formData.excel_file_url" target="_blank">查看</a>
              <span v-else>未上传</span>
            </template>
            <template v-else>
              <div class="employee-excel-upload-row">
                <span class="employee-excel-label">上传员工信息：</span>
                <el-upload
                  class="employee-excel-upload"
                  :action="uploadUrl"
                  :headers="dynamicUploadHeaders"
                  :file-list="fileList.excelFileList"
                  :before-upload="beforeEmployeeExcelUpload"
                  :on-success="handleExcelFileSuccess"
                  :on-error="handleUploadError"
                  :on-remove="handleExcelFileRemove"
                  :limit="1"
                  accept=".xls,.xlsx"
                  name="fileVal"
                  ref="excelUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <a
                  class="employee-template-link"
                  :href="employeeTemplateUrl"
                  target="_blank"
                  @click="downloadEmployeeTemplate">
                  下载员工信息模板
                </a>
              </div>
              <div class="employee-excel-tip">仅支持 xls/xlsx，上传成功后将用文件中的员工信息替换当前列表</div>
            </template>
          </div>
        </div>
        
        <!-- 导出按钮（仅在查看模式下显示） -->
        <div v-if="(formData.action || 'view') === 'view'" style="text-align: center; margin-bottom: 15px;">
          <el-button size="mini" @click="exportAllEmployees">导出所有员工信息</el-button>
          <el-button size="mini" @click="exportInsuredEmployees">导出在保员工信息</el-button>
        </div>
        
        <!-- 使用表格显示员工信息，与老项目保持一致 -->
        <div class="employee-table-container">
          <!-- 编辑模式下的员工信息表格 -->
          <table class="employee-table" border="1" v-if="(formData.action || 'view') !== 'view'">
            <thead>
              <tr>
                <th width="40">序号</th>
                <th width="70">姓名</th>
                <th width="210">身份证号</th>
                <th width="340">工作类型</th>

                <th width="70" v-if="(formData.action || 'view') !== 'check'">
                  <el-button size="mini" @click="addItem">新增</el-button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredEmployeeList" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <el-input 
                    v-model="item.name" 
                    :class="[item.is_highlight?'easyui-tooltip':'']" 
                    :title="item.is_highlight?'该名员工的年龄不符合要求，请尽快处理':''" 
                    :style="{color:item.is_highlight?'red':'#000'}"
                    size="mini" />
                </td>
                <td>
                  <el-input 
                    v-model="item.idcard" 
                    :class="[item.is_highlight?'easyui-tooltip':'']" 
                    :title="item.is_highlight?'该名员工的年龄不符合要求，请尽快处理':''" 
                    :style="{color:item.is_highlight?'red':'#000'}"
                    size="mini" />
                </td>
                <td>
                  <el-radio-group v-model="item.type" size="mini">
                    <el-radio :label="1">搬运工人</el-radio>
                    <el-radio :label="2">文员内勤</el-radio>
                    <el-radio :label="4">司机押运</el-radio>
                  </el-radio-group>
                </td>

                <td v-if="(formData.action || 'view') !== 'check'">
                  <el-button size="mini" type="danger" @click="deleteItem(index)">删除</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          
          <!-- 查看模式下的员工信息表格 -->
          <table class="employee-table" border="1" v-else>
            <thead>
              <tr>
                <th width="40">序号</th>
                <th width="70">姓名</th>
                <th width="210">身份证号</th>
                <th width="100">工作类型</th>
                <th width="80">单价(元)</th>
                <th width="160">生效日期</th>
                <th width="160">失效日期</th>

              </tr>
            </thead>
            <tbody>
              <tr v-if="filteredEmployeeList.length === 0">
                <td colspan="7" style="padding: 24px; color: #909399;">暂无在保人员</td>
              </tr>
              <tr v-for="(item, index) in filteredEmployeeList" :key="index">
                <td>{{ index + 1 }}</td>
                <td :class="[item.is_highlight?'easyui-tooltip':'']" :title="item.is_highlight?'该名员工的年龄不符合要求，请尽快处理':''" :style="{color:item.is_highlight?'red':'#000'}">{{ item.name }}</td>
                <td :class="[item.is_highlight?'easyui-tooltip':'']" :title="item.is_highlight?'该名员工的年龄不符合要求，请尽快处理':''" :style="{color:item.is_highlight?'red':'#000'}">{{ item.idcard }}</td>
                <td>{{ formatWorkType(item.type) }}</td>
                <td>{{ formatEmployeePrice(item, formData) }}</td>
                <td>{{ formatDateValue(item.effect_date) }}</td>
                <td>{{ formatDateValue(item.expire_date) }}</td>

              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- 上传附件 -->
        <h3 style="text-align: center; margin: 15px 0;">上传附件</h3>

        <el-row>
          <el-col :span="24">
            <el-form-item label="上传保单：">
              <div v-if="(formData.action || 'view') === 'view'">
                <div v-if="formData.policy_file && formData.policy_file.length > 0">
                  <div v-for="(file, index) in formData.policy_file" :key="index" style="margin-bottom: 10px;">
                    <img
                      v-if="isImageFile(getFileUrl(file))"
                      :src="getFileUrl(file)"
                      style="max-width: 200px; max-height: 200px; margin-right: 10px;" 
                      alt="保单"
                      @click="viewFile(file)"
                    />
                    <span v-else>{{ getFileName(file, index) }}</span>
                    <div style="margin-top: 6px;">
                      <el-button type="text" size="mini" @click="viewFile(file)">查看</el-button>
                      <el-button type="text" size="mini" @click="downloadFile(file, index)">下载</el-button>
                    </div>
                  </div>
                </div>
                <div v-else>未上传</div>
              </div>
              <div v-else>
                <!-- 修改为文件上传组件 -->
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="dynamicUploadHeaders"
                  :file-list="fileList.policyFileList"
                  :on-success="handlePolicyFileSuccess"
                  :on-error="handleUploadError"
                  :on-remove="handlePolicyFileRemove"
                  :limit="1"
                  name="fileVal"
                  ref="policyUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="上传投保单：">
              <div v-if="(formData.action || 'view') === 'view'">
                <div v-if="formData.proposal_url && formData.proposal_url.length > 0">
                  <div v-for="(url, index) in formData.proposal_url" :key="index" style="margin-bottom: 10px;">
                    <img 
                      v-if="isImageFile(url)" 
                      :src="url" 
                      style="max-width: 200px; max-height: 200px; margin-right: 10px;" 
                      alt="投保单"
                    />
                    <a v-else :href="url" target="_blank">查看文件 {{ index + 1 }}</a>
                  </div>
                </div>
                <div v-else>未上传</div>
              </div>
              <div v-else>
                <!-- 修改为文件上传组件 -->
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="dynamicUploadHeaders"
                  :file-list="fileList.proposalFileList"
                  :on-success="handleProposalFileSuccess"
                  :on-error="handleUploadError"
                  :on-remove="handleProposalFileRemove"
                  :limit="1"
                  name="fileVal"
                  ref="proposalUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formData.vat_invoice_open_type == 1 && formData.vat_invoice_type == 2">
          <el-col :span="12">
            <el-form-item label="开票信息采集表：">
              <div v-if="(formData.action || 'view') === 'view'">
                <div v-if="formData.vat_file_url">
                  <img 
                    v-if="isImageFile(formData.vat_file_url)" 
                    :src="formData.vat_file_url" 
                    style="max-width: 200px; max-height: 200px;" 
                    alt="开票信息采集表"
                  />
                  <a v-else :href="formData.vat_file_url" target="_blank">查看文件</a>
                </div>
                <div v-else>未上传</div>
              </div>
              <div v-else>
                <el-input v-model="formData.vat_file_url" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="一般纳税人证明材料：">
              <div v-if="(formData.action || 'view') === 'view'">
                <div v-if="formData.tax_file_url">
                  <img 
                    v-if="isImageFile(formData.tax_file_url)" 
                    :src="formData.tax_file_url" 
                    style="max-width: 200px; max-height: 200px;" 
                    alt="一般纳税人证明"
                  />
                  <a v-else :href="formData.tax_file_url" target="_blank">查看文件</a>
                </div>
                <div v-else>未上传</div>
              </div>
              <div v-else>
                <el-input v-model="formData.tax_file_url" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <div v-if="(formData.action || 'view') === 'view'">
          <el-button @click="handleClose">关闭</el-button>
        </div>
        <div v-else-if="(formData.action || 'view') === 'add'">
          <el-button @click="handleClose">取消</el-button>
          <el-button @click="handleHoldSave" :loading="holdSaveLoading">暂存</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</el-button>
        </div>
        <div v-else-if="(formData.action || 'view') === 'edit'">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</el-button>
        </div>
        <div v-else-if="(formData.action || 'view') === 'check'">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</el-button>
        </div>
        <div v-else>
          <el-button @click="handleClose">关闭</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'
import { formatDate as formatDateUtil, formatMoney as formatMoneyUtil } from '@/utils/formatter'
import { ygbOrderSave, ygbOrderEdit, ygbOrderCheck, ygbOrderHoldSave, getChannelList, ygbProductList, getInsuranceCompanyList } from '@/api/member.js'
import { getSchemeInfo, getCityList, getProvinceList } from '@/api/product.js'
import { getToken } from '@/lib/local'

export default {
  name: 'ViewDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitLoading: false,
      holdSaveLoading: false,
      formData: {
        action: 'view', // 添加默认的action属性
        // 发票相关字段默认值
        vat_invoice_open_type: '4', // 待定
        vat_invoice_type: '1', // 普票
        vat_invoice_title: '1' // 企业
      },
      // 添加省份、城市、渠道商选项数据
      provinceOptions: [],
      cityOptions: [],
      channelOptions: [],
      // 添加产品选项数据
      productOptions: [],
      allProducts: [], // 添加所有产品列表
      allChannels: [], // 添加所有渠道商列表
      channelName: '', // 添加渠道商名称
      channelId: '',   // 添加渠道商ID
      // 添加保险公司选项数据
      insuranceOptions: [],
      insuranceLoading: false,
      // 添加产品加载状态
      productLoading: false,
      // 添加文件上传相关数据
      fileList: {
        licenseFileList: [],
        taxFileList: [],
        vatFileList: [],
        policyFileList: [],
        proposalFileList: [],
        excelFileList: []
      },
      pendingEmployeeImport: null,
      employeeExcelParserPromise: null,
      // 添加上传URL配置
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      // 员工信息模板下载URL
      employeeTemplateUrl: 'https://api.rbbaotong.com/v1/hyx/static/%E6%96%B0%E7%89%88%E5%91%98%E5%B7%A5%E4%BF%9D%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BF.xls'
    }
  },
  computed: {
    // 根据action过滤员工信息
    filteredEmployeeList() {
      // 如果没有employee_list或者不是数组，返回空数组
      if (!this.formData.employee_list || !Array.isArray(this.formData.employee_list)) {
        return []
      }
      
      const action = this.formData.action || 'view'
      if (action === 'view') {
        return this.formData.employee_list.filter(this.isInsuredEmployee)
      }

      return this.formData.employee_list
    },
    channelMap() {
      let map = {};
      for (const item of this.channelOptions) {
        map[item.id] = `${item.realname}(${item.alias})`;
      }
      return map;
    },
    // 计算应付保费
    calculatedMustPrice() {
      const driverPrice = parseFloat(this.formData.driver_price) || 0;
      const clerkPrice = parseFloat(this.formData.clerk_price) || 0;
      const truckerPrice = parseFloat(this.formData.trucker_price) || 0;
      
      const driverNumber = parseInt(this.formData.driver_number) || 0;
      const clerkNumber = parseInt(this.formData.clerk_number) || 0;
      const truckerNumber = parseInt(this.formData.trucker_number) || 0;
      
      return driverPrice * driverNumber + clerkPrice * clerkNumber + truckerPrice * truckerNumber;
    },
    // 实际保费（与应付保费相同）
    calculatedActualPrice() {
      return this.calculatedMustPrice;
    },
    // 格式化显示的搬运工人单价
    formattedDriverPrice: {
      get() {
        return this.formatMoneyValue(this.formData.driver_price);
      },
      set(value) {
        // 移除格式化字符，只保留数字和小数点
        const numericValue = parseFloat(value.toString().replace(/[^\d.-]/g, '')) || 0;
        this.formData.driver_price = Math.round(numericValue * 100);
      }
    },
    // 格式化显示的文员内勤单价
    formattedClerkPrice: {
      get() {
        return this.formatMoneyValue(this.formData.clerk_price);
      },
      set(value) {
        const numericValue = parseFloat(value.toString().replace(/[^\d.-]/g, '')) || 0;
        this.formData.clerk_price = Math.round(numericValue * 100);
      }
    },
    // 格式化显示的司机押运单价
    formattedTruckerPrice: {
      get() {
        return this.formatMoneyValue(this.formData.trucker_price);
      },
      set(value) {
        const numericValue = parseFloat(value.toString().replace(/[^\d.-]/g, '')) || 0;
        this.formData.trucker_price = Math.round(numericValue * 100);
      }
    },
    // 格式化显示的录单应付保费
    formattedMustPrice: {
      get() {
        return this.formatMoneyValue(this.formData.must_price);
      },
      set(value) {
        const numericValue = parseFloat(value.toString().replace(/[^\d.-]/g, '')) || 0;
        this.formData.must_price = Math.round(numericValue * 100);
      }
    },
    // 格式化显示的录单实际保费
    formattedActualPrice: {
      get() {
        return this.formatMoneyValue(this.formData.actual_price);
      },
      set(value) {
        const numericValue = parseFloat(value.toString().replace(/[^\d.-]/g, '')) || 0;
        this.formData.actual_price = Math.round(numericValue * 100);
      }
    },
    // 动态获取上传请求头
    dynamicUploadHeaders() {
      const token = getToken('jubao_admin')
      const headers = { AppKey: 'BpLnfgDs' }
      if (token) headers.Authorization = `Bearer ${token}`
      return headers
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.formData = { ...this.rowData };
          
          // 确保发票相关字段为字符串类型，以便下拉框正确显示
          if (this.formData.vat_invoice_open_type !== undefined) {
            this.formData.vat_invoice_open_type = String(this.formData.vat_invoice_open_type);
          }
          if (this.formData.vat_invoice_type !== undefined) {
            this.formData.vat_invoice_type = String(this.formData.vat_invoice_type);
          }
          if (this.formData.vat_invoice_title !== undefined) {
            this.formData.vat_invoice_title = String(this.formData.vat_invoice_title);
          }
          this.formData.settlement_channel = String(this.formData.settlement_channel);
          // 为添加和修改模式设置发票相关字段的默认值
          const action = this.formData.action || 'view';
          if (action === 'add' || action === 'edit') {
            // 如果发票开具字段为空，设置默认值为"待定"
            if (!this.formData.vat_invoice_open_type) {
              this.formData.vat_invoice_open_type = '4'; // 待定
            }
            // 如果开票类型字段为空，设置默认值为"普票"
            if (!this.formData.vat_invoice_type) {
              this.formData.vat_invoice_type = '1'; // 普票
            }
            // 如果开票抬头字段为空，设置默认值为"企业"
            if (!this.formData.vat_invoice_title) {
              this.formData.vat_invoice_title = '1'; // 企业
            }
          }
          
          // 初始化渠道商名称和ID
          if (this.formData.channel_id && this.formData.realname) {
            this.channelName = this.formData.realname;
            this.channelId = this.formData.channel_id;
          }
          // 初始化文件列表
          this.initFileList();
          // 初始化下拉选项
          this.initSelectOptions();
        } else {
          // 对话框关闭时清空选项数据，避免数据残留
          this.productOptions = [];
          this.allProducts = [];
          this.channelOptions = [];
          this.allChannels = [];
        }
      },
      immediate: true // 立即执行一次
    },
    
    // 监听省份变化，自动更新城市选项
    'formData.province': {
      handler(newProvince, oldProvince) {
        if (newProvince && newProvince !== oldProvince) {
          console.log('省份发生变化:', oldProvince, '->', newProvince);
          
          this.cityOptions = [];
          
          // 重新获取城市选项
          this.getCityOptions();
        }
      },
      immediate: false
    },

    // 员工清单上传、手工填写、增删或切换工种时，自动回填各工种人数。
    'formData.employee_list': {
      handler() {
        if ((this.formData.action || 'view') !== 'view') {
          this.syncEmployeeTypeCounts()
        }
      },
      deep: true,
      immediate: true
    },

    // 生效时间变化后，结束时间自动设置为一年后的前一秒。
    'formData.effect_date': {
      handler(newValue) {
        if ((this.formData.action || 'view') === 'view') return
        if (!newValue) {
          this.$set(this.formData, 'expire_date', '')
          return
        }

        const effectDate = dayjs(newValue)
        if (!effectDate.isValid()) return
        this.$set(
          this.formData,
          'expire_date',
          effectDate.add(1, 'year').subtract(1, 'second').format('YYYY-MM-DD HH:mm:ss')
        )
      },
      immediate: false
    },
    
    // 监听保费计算相关字段变化，自动更新保费
    calculatedMustPrice: {
      handler(newPrice) {
        this.formData.must_price = newPrice;
      },
      immediate: true
    },
    
    calculatedActualPrice: {
      handler(newPrice) {
        this.formData.actual_price = newPrice;
      },
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    syncEmployeeTypeCounts() {
      const counts = {
        1: 0,
        2: 0,
        4: 0
      }
      const employeeList = Array.isArray(this.formData.employee_list)
        ? this.formData.employee_list
        : []

      employeeList.forEach(employee => {
        if (!employee) return
        const name = String(employee.name == null ? '' : employee.name).trim()
        const idcard = String(employee.idcard == null ? '' : employee.idcard).trim()
        const type = Number(employee.type)
        if (name && idcard && Object.prototype.hasOwnProperty.call(counts, type)) {
          counts[type] += 1
        }
      })

      this.$set(this.formData, 'driver_number', counts[1])
      this.$set(this.formData, 'clerk_number', counts[2])
      this.$set(this.formData, 'trucker_number', counts[4])
    },
    // 初始化文件列表
    initFileList() {
      this.fileList = {
        licenseFileList: [],
        taxFileList: [],
        vatFileList: [],
        policyFileList: [],
        proposalFileList: [],
        excelFileList: []
      }

      // 初始化营业执照文件列表
      if (this.formData.license_file_url) {
        this.fileList.licenseFileList = [{
          name: '营业执照.jpg',
          url: this.formData.license_file_url
        }]
      }
      
      // 初始化一般纳税人证明文件列表
      if (this.formData.tax_file_url) {
        this.fileList.taxFileList = [{
          name: '一般纳税人证明.jpg',
          url: this.formData.tax_file_url
        }]
      }
      
      // 初始化开票信息采集表文件列表
      if (this.formData.vat_file_url) {
        this.fileList.vatFileList = [{
          name: '开票信息采集表.jpg',
          url: this.formData.vat_file_url
        }]
      }
      
      // 初始化保单文件列表
      if (this.formData.policy_file && this.formData.policy_file.length > 0) {
        this.fileList.policyFileList = this.formData.policy_file.map(file => ({
          name: file.name || '保单文件.jpg',
          url: file.url
        }))
      }
      
      // 初始化投保单文件列表
      if (this.formData.proposal_url && this.formData.proposal_url.length > 0) {
        this.fileList.proposalFileList = this.formData.proposal_url.map(url => ({
          name: '投保单.jpg',
          url: url
        }))
      }
      

      
      // 初始化员工信息文件列表
      if (this.formData.excel_file_url) {
        this.fileList.excelFileList = [{
          name: '员工信息.xlsx',
          url: this.formData.excel_file_url
        }]
      }
    },
    
    // 修改渠道选择变化处理方法
    handleChannelChange(val) {
      // 设置选中的渠道名称
      this.channelName = val;
      
      // 重置渠道ID
      this.channelId = '';
      this.formData.channel_id = '';
      
      if (val) {
        const selectedChannel = this.allChannels.find(channel => 
          channel.realname === val
        );
        if (selectedChannel) {
          this.channelId = selectedChannel.id;
          // 同时更新formData中的channel_id
          this.formData.channel_id = selectedChannel.id;
        }
      }
    },
    // 获取渠道商选项
    getChannelOptions(query) {
      const params = {
        page: 1
      }
      
      if (query) {
        params.keyword = query
      }
      
      // 显示加载状态
      this.loading = true;
      
      // 直接调用API获取渠道商列表
      return getChannelList(params).then(response => {
        this.loading = false;
        if (response && response.err_code === 0) {
          this.allChannels = response.rows || [];
          
          if (query) {
            this.channelOptions = (response.rows || []).filter(item => {
              const realname = item.realname || '';
              const alias = item.alias || '';
              const searchStr = realname + alias;
              return searchStr.toLowerCase().includes(query.toLowerCase());
            });
          } else {
            this.channelOptions = response.rows || [];
          }
          return response;
        } else {
          console.error('获取渠道商列表失败:', response ? response.err_msg : '未知错误')
          this.$message.error('获取渠道商列表失败: ' + (response ? response.err_msg : '未知错误'))
          this.channelOptions = [];
          return Promise.reject(response ? response.err_msg : '未知错误');
        }
      }).catch(error => {
        this.productLoading = false;
        console.error('获取渠道商列表失败:', error)
        this.$message.error('获取渠道商列表失败: ' + (error.message || '网络错误'))
        this.channelOptions = [];
        return Promise.reject(error);
      })
    },
    
    // 添加产品选择变化处理方法
    handleProductChange(val) {
      // 当产品选择变化时，更新产品名称
      if (val) {
        const selectedProduct = this.allProducts.find(product => 
          product.id == val || 
          String(product.id) === String(val)
        );
        if (selectedProduct) {
          this.$set(this.formData, 'product_name', selectedProduct.name);
          console.log('产品选择变化:', selectedProduct);
          
          // 自动填充价格信息
          this.loadProductPrices(val);
        }
      } else {
        this.$set(this.formData, 'product_name', '');
        // 清空价格信息
        this.$set(this.formData, 'driver_price', 0);
        this.$set(this.formData, 'clerk_price', 0);
        this.$set(this.formData, 'trucker_price', 0);
      }
    },
    
    // 加载产品价格信息
    loadProductPrices(productId) {
      if (!productId) {
        console.log('缺少产品ID，无法获取价格');
        return;
      }
      
      const params = {
        product_id: productId
      };
      
      console.log('获取产品价格参数:', params);
      
      // 调用产品价格API
      getSchemeInfo(params).then(response => {
        console.log('产品价格API响应:', response);
        
        if (response && response.err_code === 0 && response.rows) {
          const priceDataArray = response.rows;
          
          console.log('解析的价格数据数组:', priceDataArray);
          
          if (Array.isArray(priceDataArray) && priceDataArray.length > 0) {
            let hasPrice = false;
            
            // 遍历价格数据数组，根据employee_type设置对应的价格
            priceDataArray.forEach(item => {
              if (item.employee_type && item.price !== undefined && item.price !== null) {
                // 接口返回的价格单位固定为分，保留原值交给金额格式化方法统一转换为元
                const price = Number(item.price);
                
                switch (item.employee_type) {
                  case 1: // 搬运工人
                    this.$set(this.formData, 'driver_price', price);
                    hasPrice = true;
                    console.log('设置搬运工人价格:', price);
                    break;
                  case 2: // 文员内勤
                    this.$set(this.formData, 'clerk_price', price);
                    hasPrice = true;
                    console.log('设置文员内勤价格:', price);
                    break;
                  case 4: // 司机押运
                    this.$set(this.formData, 'trucker_price', price);
                    hasPrice = true;
                    console.log('设置司机押运价格:', price);
                    break;
                  default:
                    console.log('未知的员工类型:', item.employee_type);
                }
              }
            });
            
            // 强制触发视图更新
            this.$forceUpdate();
            
            if (hasPrice) {
              this.$message.success('已自动填充产品价格信息');
            } else {
              console.log('API返回数据中未找到有效的价格信息');
            }
          } else {
            console.log('API返回的价格数据不是数组或为空:', priceDataArray);
          }
        } else {
          console.log('API返回错误或无数据:', response);
        }
      }).catch(error => {
        console.error('获取产品价格失败:', error);
        this.$message.error('获取产品价格失败，请稍后重试');
      });
    },
    // 获取产品选项
    getProductOptions(query) {
      const params = {
        page: 1,
        limit: 100  // 增加限制数量，确保获取足够的数据
      }
      
      if (query) {
        params.keyword = query
      }
      
      // 显示加载状态
      this.productLoading = true;
      
      // 调用API获取产品列表
      return ygbProductList(params).then(response => {
        this.productLoading = false;
        console.log('产品列表API响应:', response);
        
        if (response && response.err_code === 0) {
          // 检查响应数据结构，可能是response.data或response.rows
          const productData = response.data || response.rows || [];
          this.allProducts = productData;
          
          if (query) {
            this.productOptions = productData.filter(item => {
              const name = item.name || '';
              return name.toLowerCase().includes(query.toLowerCase());
            });
          } else {
            this.productOptions = productData;
          }
          
          console.log('产品选项数据:', this.productOptions);
          return response;
        } else {
          console.error('获取产品列表失败:', response ? response.err_msg : '未知错误')
          this.$message.error('获取产品列表失败: ' + (response ? response.err_msg : '未知错误'))
          this.productOptions = [];
          this.allProducts = [];
          return Promise.reject(response ? response.err_msg : '未知错误');
        }
      }).catch(error => {
        this.productLoading = false;
        console.error('获取产品列表失败:', error)
        this.$message.error('获取产品列表失败: ' + (error.message || '网络错误'))
        this.productOptions = [];
        this.allProducts = [];
        return Promise.reject(error);
      })
    },
    
    // 获取保险公司选项
    getInsuranceOptions(query) {
      const params = {
        type: 1  // 参考List.vue中的参数
      }
      
      if (query) {
        params.keyword = query
      }
      
      // 显示加载状态
      this.insuranceLoading = true;
      
      // 调用API获取保险公司列表
      return getInsuranceCompanyList(params).then(response => {
        this.insuranceLoading = false;
        if (response && response.err_code === 0) {
          if (query) {
            // 如果有搜索关键词，进行模糊匹配
            this.insuranceOptions = (response.rows || []).filter(item => {
              const name = item.name || '';
              return name.toLowerCase().includes(query.toLowerCase());
            });
          } else {
            this.insuranceOptions = response.rows || [];
          }
          console.log('保险公司选项数据:', this.insuranceOptions);
          return response;
        } else {
          console.error('获取保险公司列表失败:', response ? response.err_msg : '未知错误')
          this.$message.error('获取保险公司列表失败: ' + (response ? response.err_msg : '未知错误'))
          this.insuranceOptions = [];
          return Promise.reject(response ? response.err_msg : '未知错误');
        }
      }).catch(error => {
        this.insuranceLoading = false;
        console.error('获取保险公司列表失败:', error)
        this.$message.error('获取保险公司列表失败: ' + (error.message || '网络错误'))
        this.insuranceOptions = [];
        return Promise.reject(error);
      })
    },
    
    // 修改初始化下拉选项方法
    initSelectOptions() {
      // 初始化产品选项
      this.getProductOptions('').then(() => {
        // 产品选项加载完成后，如果formData中有product_id，确保它能正确显示
        if (this.formData.product_id && this.allProducts.length > 0) {
          // 查找当前选中的产品，支持字符串和数字类型的ID比较
          const selectedProduct = this.allProducts.find(item => 
            item.id == this.formData.product_id || 
            String(item.id) === String(this.formData.product_id)
          );
          if (selectedProduct) {
            // 确保product_name也被设置，以便在查看模式下正确显示
            this.$set(this.formData, 'product_name', selectedProduct.name);
            console.log('找到匹配的产品:', selectedProduct);
          } else {
            console.warn('未找到匹配的产品，product_id:', this.formData.product_id, '可用产品:', this.allProducts);
          }
        }
      }).catch((error) => {
        console.error('获取产品列表失败:', error);
        // 即使获取产品列表失败，也要确保如果有product_id和名称，能正确显示
        if (this.formData.product_id && this.formData.product_name) {
          this.allProducts = [{
            id: this.formData.product_id,
            name: this.formData.product_name
          }];
          this.productOptions = [{
            id: this.formData.product_id,
            name: this.formData.product_name
          }];
          console.log('使用备用产品数据:', this.productOptions);
        }
      });
      
      // 初始化渠道商选项
      this.getChannelOptions('').then(() => {
        // 渠道商选项加载完成后，如果formData中有channel_id，确保它能正确显示
        if (this.formData.channel_id && this.allChannels.length > 0) {
          // 查找当前选中的渠道商
          const selectedChannel = this.allChannels.find(item => item.id === this.formData.channel_id);
          if (selectedChannel) {
            this.channelName = selectedChannel.realname;
            this.channelId = selectedChannel.id;
          } else if (this.formData.realname || this.formData.alias) {
            // 如果当前选中的渠道商不在选项中，但有名称，添加到选项中
            this.allChannels.unshift({
              id: this.formData.channel_id,
              realname: this.formData.realname,
              alias: this.formData.alias
            });
            this.channelName = this.formData.realname;
            this.channelId = this.formData.channel_id;
          }
        }
      }).catch(() => {
        // 即使获取渠道商列表失败，也要确保如果有channel_id和名称，能正确显示
        if (this.formData.channel_id && (this.formData.realname || this.formData.alias)) {
          this.allChannels = [{
            id: this.formData.channel_id,
            realname: this.formData.realname,
            alias: this.formData.alias
          }];
          this.channelOptions = [{
            id: this.formData.channel_id,
            realname: this.formData.realname,
            alias: this.formData.alias
          }];
          this.channelName = this.formData.realname;
          this.channelId = this.formData.channel_id;
        }
      });
      
      // 初始化保险公司选项
      this.getInsuranceOptions('').then(() => {
        // 保险公司选项加载完成后，如果formData中有insurance_type，确保它能正确显示
        if (this.formData.insurance_type && this.insuranceOptions.length > 0) {
          // 查找当前选中的保险公司
          const selectedInsurance = this.insuranceOptions.find(item => 
            item.id == this.formData.insurance_type || 
            String(item.id) === String(this.formData.insurance_type)
          );
          if (selectedInsurance) {
            console.log('找到匹配的保险公司:', selectedInsurance);
          } else {
            console.warn('未找到匹配的保险公司，insurance_type:', this.formData.insurance_type, '可用保险公司:', this.insuranceOptions);
          }
        }
      }).catch((error) => {
        console.error('获取保险公司列表失败:', error);
      });
      
      // 初始化省份选项
      this.getProvinceOptions('');
      
      // 初始化城市选项
      this.getCityOptions('');
    },
    
    // 新增员工信息
    addItem() {
      // 确保employee_list存在
      if (!this.formData.employee_list) {
        this.$set(this.formData, 'employee_list', [])
      }
      
      // 添加新的员工信息项
      this.formData.employee_list.push({
        name: "",
        idcard: "",
        type: 1,
        is_highlight: false
      })
    },
    // 删除员工信息
    deleteItem(index) {
      // 确保至少保留一个员工信息
      if (this.formData.employee_list && this.formData.employee_list.length > 1) {
        this.formData.employee_list.splice(index, 1)
      } else {
        this.$message.warning('最少需要一个员工信息！')
      }
    },
    // 数据校验方法
    checkData() {
      const errArr = [];
      
      // 基本信息校验
      if (!this.formData.policyholder || this.formData.policyholder.trim() === '') {
        errArr.push('请填写投保人');
        return { valid: false, message: errArr[0] };
      }
      
      if (!this.formData.beneficiary || this.formData.beneficiary.trim() === '') {
        errArr.push('请填写被保险人');
        return { valid: false, message: errArr[0] };
      }
      
      if (!this.formData.channel_id) {
        errArr.push('请选择渠道');
        return { valid: false, message: errArr[0] };
      }
      
      if (!this.formData.city || this.formData.city.trim() === '') {
        errArr.push('请选择城市');
        return { valid: false, message: errArr[0] };
      }
      
      if (!this.formData.province || this.formData.province.trim() === '') {
        errArr.push('请选择省份');
        return { valid: false, message: errArr[0] };
      }
      
      if (!this.formData.product_id) {
        errArr.push('请选择产品类型');
        return { valid: false, message: errArr[0] };
      }
      
      // 公司名称与纳税人名称一致性校验
      if (this.formData.tax_name && this.formData.tax_name.trim() !== '' && 
          this.formData.beneficiary && this.formData.beneficiary.trim() !== '' &&
          this.formData.tax_name.trim() !== this.formData.beneficiary.trim()) {
        errArr.push('公司名称与纳税人名称不一致');
        return { valid: false, message: errArr[0] };
      }
      
      // 保费校验
      if (!this.formData.actual_price || parseFloat(this.formData.actual_price) <= 0) {
        errArr.push('请填写正确的实际保费');
        return { valid: false, message: errArr[0] };
      }
      
      // 时间校验
      if (!this.formData.effect_date) {
        errArr.push('请选择生效时间');
        return { valid: false, message: errArr[0] };
      }
      
      if (!this.formData.expire_date) {
        errArr.push('请选择结束时间');
        return { valid: false, message: errArr[0] };
      }
      
      // 日期比较校验
      const effectDate = new Date(this.formData.effect_date);
      const expireDate = new Date(this.formData.expire_date);
      
      if (effectDate >= expireDate) {
        errArr.push('生效时间不能大于或等于结束时间');
        return { valid: false, message: errArr[0] };
      }
      
      // 员工信息校验
      if (!this.formData.employee_list || this.formData.employee_list.length === 0) {
        errArr.push('请添加员工信息');
        return { valid: false, message: errArr[0] };
      }
      
      // 身份证正则表达式
      const identity = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/;
      
      // 员工信息去重和校验
      const nameIdcardSet = new Set();
      let driver_num = 0, clerk_num = 0, trucker_num = 0;
      
      for (let i = 0; i < this.formData.employee_list.length; i++) {
        const item = this.formData.employee_list[i];
        
        // 必填项校验
        if (!item.name || item.name.trim() === '') {
          errArr.push(`第${i + 1}行员工姓名不能为空`);
          return { valid: false, message: errArr[0] };
        }
        
        if (!item.idcard || item.idcard.trim() === '') {
          errArr.push(`第${i + 1}行员工身份证号不能为空`);
          return { valid: false, message: errArr[0] };
        }
        
        // 身份证格式校验
        if (!identity.test(item.idcard)) {
          errArr.push(`第${i + 1}行员工身份证号格式不正确`);
          return { valid: false, message: errArr[0] };
        }
        
        // 姓名身份证去重校验
        const nameIdcard = `${item.name.trim()}_${item.idcard.trim()}`;
        if (nameIdcardSet.has(nameIdcard)) {
          errArr.push(`员工信息存在重复：${item.name}(${item.idcard})`);
          return { valid: false, message: errArr[0] };
        }
        nameIdcardSet.add(nameIdcard);
        
        // 统计各类型人数
        if (item.type == 1) driver_num++;
        else if (item.type == 2) clerk_num++;
        else if (item.type == 4) trucker_num++;
        
        // 年龄校验
        const age = this.getAgeFromIdcard(item.idcard);
        if (age < 16) {
          errArr.push(`员工${item.name}未满16周岁，请仔细核对`);
          return { valid: false, message: errArr[0] };
        }
        if (age > 65) {
          errArr.push(`员工${item.name}超过65周岁，请仔细核对`);
          return { valid: false, message: errArr[0] };
        }
      }
      
      // 人数校验
      const totalDrivers = parseInt(this.formData.driver_number) || 0;
      const totalClerks = parseInt(this.formData.clerk_number) || 0;
      const totalTruckers = parseInt(this.formData.trucker_number) || 0;
      
      if (driver_num !== totalDrivers || clerk_num !== totalClerks || trucker_num !== totalTruckers) {
        errArr.push('您填入的人数与实际数据不符，请检查');
        return { valid: false, message: errArr[0] };
      }
      
      return { valid: true, message: '校验通过' };
    },
    
    // 从身份证号获取年龄
    getAgeFromIdcard(idcard) {
      if (!idcard) return 0;
      
      let birthYear, birthMonth, birthDay;
      
      if (idcard.length === 18) {
        birthYear = parseInt(idcard.substr(6, 4));
        birthMonth = parseInt(idcard.substr(10, 2));
        birthDay = parseInt(idcard.substr(12, 2));
      } else if (idcard.length === 15) {
        birthYear = parseInt('19' + idcard.substr(6, 2));
        birthMonth = parseInt(idcard.substr(8, 2));
        birthDay = parseInt(idcard.substr(10, 2));
      } else {
        return 0;
      }
      
      const today = new Date();
      const birthDate = new Date(birthYear, birthMonth - 1, birthDay);
      
      let age = today.getFullYear() - birthYear;
      if (today.getMonth() < birthMonth - 1 || 
          (today.getMonth() === birthMonth - 1 && today.getDate() < birthDay)) {
        age--;
      }
      
      return age;
    },
    
    // 处理暂存保单
    async handleHoldSave() {
      // 先进行数据校验
      const checkResult = this.checkData();
      if (!checkResult.valid) {
        this.$message.error(checkResult.message);
        return;
      }
      
      this.holdSaveLoading = true;
      
      try {
        // 构建参数对象
        const params = {
          channel_id: this.formData.channel_id,
          policyholder: this.formData.policyholder,
          beneficiary: this.formData.beneficiary,
          mobile: this.formData.mobile,
          settlement_channel: Number(this.formData.settlement_channel),
          province: this.formData.province,
          city: this.formData.city,
          license_file_url: this.formData.license_file_url,
          policy_no: this.formData.policy_no,
          product_id: Number(this.formData.product_id),
          price_driver: Math.round(Number(this.formData.driver_price) || 0),
          price_clerk: Math.round(Number(this.formData.clerk_price) || 0),
          price_trucker: Math.round(Number(this.formData.trucker_price) || 0),
          unit_type: 1,
          created_at: this.formData.created_at ? Math.floor(new Date(this.formData.created_at).getTime() / 1000) : null,
          effect_date: this.formData.effect_date ? Math.floor(new Date(this.formData.effect_date).getTime() / 1000) : null,
          expire_date: this.formData.expire_date ? Math.floor(new Date(this.formData.expire_date).getTime() / 1000) : null,
          price: Math.round(Number(this.formData.must_price) || 0),
          pay_price: Math.round(Number(this.formData.actual_price) || 0),
          employee_list: this.formData.employee_list || [],
          policy_file: this.formData.policy_file || [],
          proposal_url: this.formData.proposal_url || []
        };
        
        // 添加发票相关信息
        if (this.formData.vat_invoice_open_type == 1) {
          params.vat_invoice_type = this.formData.vat_invoice_type;
          if (this.formData.vat_invoice_type == 1) {
            params.vat_invoice_title = this.formData.vat_invoice_title;
            if (this.formData.vat_invoice_title == 1) {
              params.tax_name = this.formData.tax_name;
              params.tax_no = this.formData.tax_no;
            } else if (this.formData.vat_invoice_title == 2) {
              params.individual_title_name = this.formData.individual_title_name;
            }
          } else if (this.formData.vat_invoice_type == 2) {
            params.tax_name = this.formData.tax_name;
            params.tax_no = this.formData.tax_no;
            params.tax_address = this.formData.tax_address;
            params.tax_mobile = this.formData.tax_mobile;
            params.tax_bank = this.formData.tax_bank;
            params.tax_bank_no = this.formData.tax_bank_no;
            params.tax_file_url = this.formData.tax_file_url;
            params.vat_file_url = this.formData.vat_file_url;
          }
        }
        params.vat_invoice_open_type = this.formData.vat_invoice_open_type;
        
        // 添加Excel文件URL
        if (this.formData.excel_file_url) {
          params.excel_file_url = this.formData.excel_file_url;
        }
        
        const response = await ygbOrderHoldSave(params);
        
        if (response.data.err_code === 0) {
          this.$message.success('暂存成功');
          this.$emit('success');
          this.handleClose();
        } else {
          this.$message.error(response.data.err_msg || '暂存失败');
        }
      } catch (error) {
        console.error('暂存保单失败:', error);
        this.$message.error('暂存失败，请确认信息都已完善');
      } finally {
        this.holdSaveLoading = false;
      }
    },
    
    // 处理表单提交
    handleSubmit() {
      // 先进行数据校验
      const checkResult = this.checkData();
      if (!checkResult.valid) {
        this.$message.error(checkResult.message);
        return;
      }
      
      // 根据action参数决定如何处理提交
      const action = this.formData.action || 'view'
      
      if (action === 'add') {
        // 添加保单逻辑
        this.handleAddOrder()
      } else if (action === 'edit') {
        // 编辑保单逻辑
        this.handleEditOrder()
      } else if (action === 'check') {
        // 修改保单逻辑
        this.handleCheckOrder()
      } else {
        // 查看模式直接关闭
        this.handleClose()
      }
    },
    
    // 改进的添加保单方法
    handleAddOrder() {
      this.submitLoading = true;
      
      // 调试：检查文件数据
      console.log('提交时的formData文件信息:', {
        license_file_url: this.formData.license_file_url,
        excel_file_url: this.formData.excel_file_url,
        policy_file: this.formData.policy_file,
        proposal_url: this.formData.proposal_url,
        tax_file_url: this.formData.tax_file_url,
        vat_file_url: this.formData.vat_file_url
      });
      
      // 构造请求参数
      const params = {
          // 基本信息
          policyholder: this.formData.policyholder,
          beneficiary: this.formData.beneficiary,
          mobile: this.formData.mobile,
          policy_no: this.formData.policy_no,
          product_id: this.formData.product_id,
          // 价格信息
          price_driver: Math.round(Number(this.formData.driver_price) || 0),
          price_clerk: Math.round(Number(this.formData.clerk_price) || 0),
          price_trucker: Math.round(Number(this.formData.trucker_price) || 0),
          // 人数信息
          driver_number: this.formData.driver_number,
          clerk_number: this.formData.clerk_number,
          trucker_number: this.formData.trucker_number,
          // 时间信息
          created_at: this.formData.created_at ? Math.floor(new Date(this.formData.created_at).getTime() / 1000) : null,
          effect_date: this.formData.effect_date ? Math.floor(new Date(this.formData.effect_date).getTime() / 1000) : null,
          expire_date: this.formData.expire_date ? Math.floor(new Date(this.formData.expire_date).getTime() / 1000) : null,
          // 价格信息
          price: Math.round(Number(this.formData.must_price) || 0),
          pay_price: Math.round(Number(this.formData.actual_price) || 0),
          // 员工列表
          employee_list: this.formData.employee_list || [],
          // 结算渠道
          settlement_channel: parseInt(this.formData.settlement_channel) || 0,
          // 其他信息
          province: this.formData.province,
          city: this.formData.city,
          // 使用channelId而不是formData.channel_id
          channel_id: this.channelId,
          // 发票信息
          vat_invoice_open_type: parseInt(this.formData.vat_invoice_open_type) || 0,
          vat_invoice_type: parseInt(this.formData.vat_invoice_type) || 0,
          vat_invoice_title: parseInt(this.formData.vat_invoice_title) || 0,
          individual_title_name: this.formData.individual_title_name,
          tax_name: this.formData.tax_name,
          tax_no: this.formData.tax_no,
          tax_address: this.formData.tax_address,
          tax_mobile: this.formData.tax_mobile,
          tax_bank: this.formData.tax_bank,
          tax_bank_no: this.formData.tax_bank_no,
          // 文件信息
          license_file_url: this.formData.license_file_url,
          tax_file_url: this.formData.tax_file_url,
          vat_file_url: this.formData.vat_file_url,
          excel_file_url: this.formData.excel_file_url,
          policy_file: this.formData.policy_file || [],
          proposal_url: this.formData.proposal_url || [],
          unit_type:1,
      }
      console.log('添加保单参数:', params);
      
      // 调用API保存
      ygbOrderSave(params).then(response => {
        if (response && response.err_code === 0) {
          this.$message.success('添加保单成功')
          this.handleClose()
          // 触发成功事件，通知父组件刷新数据
          this.$emit('success')
        } else {
          this.$message.error(response.err_msg || '添加保单失败')
        }
        this.submitLoading = false
      }).catch(error => {
        console.error('添加保单失败:', error)
        this.$message.error('添加保单失败: ' + (error.message || '未知错误'))
        this.submitLoading = false
      })
    },
    
    // 改进的编辑保单方法
    handleEditOrder() {
      this.submitLoading = true;
      
      // 构造请求参数
      const params = {
        order_id: this.formData.id,
          // 基本信息
          policyholder: this.formData.policyholder,
          beneficiary: this.formData.beneficiary,
          mobile: this.formData.mobile,
          policy_no: this.formData.policy_no,
          product_id: this.formData.product_id,
          // 价格信息
          price_driver: Math.round(Number(this.formData.driver_price) || 0),
          price_clerk: Math.round(Number(this.formData.clerk_price) || 0),
          price_trucker: Math.round(Number(this.formData.trucker_price) || 0),
          // 人数信息
          driver_number: this.formData.driver_number,
          clerk_number: this.formData.clerk_number,
          trucker_number: this.formData.trucker_number,
          // 时间信息
          created_at: this.formData.created_at ? Math.floor(new Date(this.formData.created_at).getTime() / 1000) : null,
          effect_date: this.formData.effect_date ? Math.floor(new Date(this.formData.effect_date).getTime() / 1000) : null,
          expire_date: this.formData.expire_date ? Math.floor(new Date(this.formData.expire_date).getTime() / 1000) : null,
          // 价格信息
          price: Math.round(Number(this.formData.must_price) || 0),
          pay_price: Math.round(Number(this.formData.actual_price) || 0),
          // 员工列表
          employee_list: this.formData.employee_list || [],
          // 结算渠道
          settlement_channel: parseInt(this.formData.settlement_channel) || 0,
          // 其他信息
          province: this.formData.province,
          city: this.formData.city,
          // 使用channelId而不是formData.channel_id
          channel_id: this.channelId,
          // 发票信息
          vat_invoice_open_type: parseInt(this.formData.vat_invoice_open_type) || 0,
          vat_invoice_type: parseInt(this.formData.vat_invoice_type) || 0,
          vat_invoice_title: parseInt(this.formData.vat_invoice_title) || 0,
          individual_title_name: this.formData.individual_title_name,
          tax_name: this.formData.tax_name,
          tax_no: this.formData.tax_no,
          tax_address: this.formData.tax_address,
          tax_mobile: this.formData.tax_mobile,
          tax_bank: this.formData.tax_bank,
          tax_bank_no: this.formData.tax_bank_no,
          // 文件信息
          license_file_url: this.formData.license_file_url,
          tax_file_url: this.formData.tax_file_url,
          vat_file_url: this.formData.vat_file_url,
          excel_file_url: this.formData.excel_file_url,
          policy_file: this.formData.policy_file || [],
          proposal_url: this.formData.proposal_url || []
        }
        
        // 调用API保存
        ygbOrderEdit(params).then(response => {
          if (response && response.err_code === 0) {
            this.$message.success('编辑保单成功')
            this.handleClose()
            // 触发成功事件，通知父组件刷新数据
            this.$emit('success')
          } else {
            this.$message.error(response.err_msg || '编辑保单失败')
          }
          this.submitLoading = false
      }).catch(error => {
        console.error('编辑保单失败:', error)
        this.$message.error('编辑保单失败: ' + (error.message || '未知错误'))
        this.submitLoading = false
      })
    },
    
    // 改进的修改保单方法
    handleCheckOrder() {
      this.submitLoading = true;
      
      // 构造请求参数
      const params = {
          id: this.formData.id,
          // 基本信息
          policyholder: this.formData.policyholder,
          beneficiary: this.formData.beneficiary,
          mobile: this.formData.mobile,
          policy_no: this.formData.policy_no,
          product_id: this.formData.product_id,
          // 价格信息
          price_driver: Math.round(Number(this.formData.driver_price) || 0),
          price_clerk: Math.round(Number(this.formData.clerk_price) || 0),
          price_trucker: Math.round(Number(this.formData.trucker_price) || 0),
          unit_type: Number(this.formData.unit_type) || 1,
          // 人数信息
          driver_number: this.formData.driver_number,
          clerk_number: this.formData.clerk_number,
          trucker_number: this.formData.trucker_number,
          // 时间信息
          created_at: this.formData.created_at ? Math.floor(new Date(this.formData.created_at).getTime() / 1000) : null,
          effect_date: this.formData.effect_date ? Math.floor(new Date(this.formData.effect_date).getTime() / 1000) : null,
          expire_date: this.formData.expire_date ? Math.floor(new Date(this.formData.expire_date).getTime() / 1000) : null,
          // 价格信息
          price: Math.round(Number(this.formData.must_price) || 0),
          pay_price: Math.round(Number(this.formData.actual_price) || 0),
          // 员工列表
          employee_list: this.formData.employee_list || [],
          // 结算渠道
          settlement_channel: parseInt(this.formData.settlement_channel, 10) || 0,
          // 其他信息
          province: this.formData.province,
          city: this.formData.city,
          // 使用channelId而不是formData.channel_id
          channel_id: this.channelId,
          // 发票信息
          vat_invoice_open_type: parseInt(this.formData.vat_invoice_open_type, 10) || 0,
          vat_invoice_type: parseInt(this.formData.vat_invoice_type, 10) || 0,
          vat_invoice_title: parseInt(this.formData.vat_invoice_title, 10) || 0,
          individual_title_name: this.formData.individual_title_name,
          tax_name: this.formData.tax_name,
          tax_no: this.formData.tax_no,
          tax_address: this.formData.tax_address,
          tax_mobile: this.formData.tax_mobile,
          tax_bank: this.formData.tax_bank,
          tax_bank_no: this.formData.tax_bank_no,
          // 文件信息
          license_file_url: this.formData.license_file_url,
          tax_file_url: this.formData.tax_file_url,
          vat_file_url: this.formData.vat_file_url,
          excel_file_url: this.formData.excel_file_url,
          policy_file: this.formData.policy_file || [],
          proposal_url: this.formData.proposal_url || []
        }
        
        // 调用API保存
        ygbOrderCheck(params).then(response => {
          if (response && response.err_code === 0) {
            this.$message.success('修改保单成功')
            this.handleClose()
            // 触发成功事件，通知父组件刷新数据
            this.$emit('success')
          } else {
            this.$message.error(response.err_msg || '修改保单失败')
          }
          this.submitLoading = false
        }).catch(error => {
          console.error('修改保单失败:', error)
          this.$message.error('修改保单失败: ' + (error.message || '未知错误'))
          this.submitLoading = false
        })
    },
    // 手动触发文件上传
    submitUpload(refName) {
      this.$refs[refName].submit();
    },
    
    // 文件上传错误处理方法
    handleUploadError(err, file, fileList) {
      console.error('文件上传失败:', err);
      this.$message.error('文件上传失败: ' + (err.message || '未知错误'));
    },
    isInsuredEmployee(employee) {
      return employee && (employee.status === undefined || employee.status === null || employee.status === '' || Number(employee.status) === 1)
    },
    
    // 导出所有员工信息
    exportAllEmployees() {
      if (!this.formData.employee_list || this.formData.employee_list.length === 0) {
        this.$message.warning('没有员工信息可导出')
        return
      }
      
      // 获取所有员工信息
      const exportList = this.formData.employee_list || []
      
      if (exportList.length === 0) {
        this.$message.warning('没有符合条件的员工信息可导出')
        return
      }
      
      const rows = []
      let product1 = ""
      let product2 = ""
      let product3 = ""
      let product4 = ""
      
      // 根据产品ID设置产品信息
      if (this.formData.product_id == 1) {
        product1 = '60万'
        product2 = '6万'
        product3 = '100元/天'
        product4 = ''
      } else if (this.formData.product_id == 2) {
        product1 = '20万'
        product2 = '2万'
        product3 = '100元/天'
        product4 = ''
      } else if (this.formData.product_id == 3) {
        product1 = '40万'
        product2 = '4万'
        product3 = '100元/天'
        product4 = ''
      } else if (this.formData.product_id == 4) {
        product1 = '60万'
        product2 = '6万'
        product3 = '100元/天'
        product4 = '100元/天'
      }
      
      // 构造导出数据
      for (const item of exportList) {
        const row = {}
        row["name"] = item.name
        row["idcard"] = item.idcard
        if (item.type == 1) {
          row["type"] = '搬运工人'
        } else if (item.type == 2) {
          row["type"] = '文员内勤'
        } else if (item.type == 4) {
          row["type"] = '司机押运'
        }
        row["product1"] = product1
        row["product2"] = product2
        row["product3"] = product3
        row["product4"] = product4
        rows.push(row)
      }
      
      // 使用原生JavaScript创建并下载Excel文件
      const fileName = '员工信息表.xlsx'
      this.exportToExcel(rows, fileName, ['姓名', '身份证号码', '工种类别', '死亡伤残限额', '医疗限额', '误工费', '住院津贴'])
    },
    // 导出在保员工信息
    exportInsuredEmployees() {
      if (!this.formData.employee_list || this.formData.employee_list.length === 0) {
        this.$message.warning('没有员工信息可导出')
        return
      }
      
      const exportList = (this.formData.employee_list || []).filter(this.isInsuredEmployee)
      
      if (exportList.length === 0) {
        this.$message.warning('没有在保员工信息可导出')
        return
      }
      
      const rows = []
      let product1 = ""
      let product2 = ""
      let product3 = ""
      let product4 = ""
      
      // 根据产品ID设置产品信息
      if (this.formData.product_id == 1) {
        product1 = '60万'
        product2 = '6万'
        product3 = '100元/天'
        product4 = ''
      } else if (this.formData.product_id == 2) {
        product1 = '20万'
        product2 = '2万'
        product3 = '100元/天'
        product4 = ''
      } else if (this.formData.product_id == 3) {
        product1 = '40万'
        product2 = '4万'
        product3 = '100元/天'
        product4 = ''
      } else if (this.formData.product_id == 4) {
        product1 = '60万'
        product2 = '6万'
        product3 = '100元/天'
        product4 = '100元/天'
      }
      
      // 构造导出数据
      for (const item of exportList) {
        const row = {}
        row["name"] = item.name
        row["idcard"] = item.idcard
        if (item.type == 1) {
          row["type"] = '搬运工人'
        } else if (item.type == 2) {
          row["type"] = '文员内勤'
        } else if (item.type == 4) {
          row["type"] = '司机押运'
        }
        row["product1"] = product1
        row["product2"] = product2
        row["product3"] = product3
        row["product4"] = product4
        rows.push(row)
      }
      
      // 使用原生JavaScript创建并下载Excel文件
      const fileName = '在保员工信息表.xlsx'
      this.exportToExcel(rows, fileName, ['姓名', '身份证号码', '工种类别', '死亡伤残限额', '医疗限额', '误工费', '住院津贴'])
    },
    // 导出Excel文件的通用方法
    exportToExcel(data, fileName, headers) {
      // 创建工作簿
      const wb = XLSX.utils.book_new()
      
      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(data)
      
      // 设置表头
      const headerRow = {}
      headers.forEach((header, index) => {
        const col = String.fromCharCode(65 + index) // A, B, C, ...
        headerRow[col + '1'] = header
      })
      
      // 合并表头
      Object.assign(ws, headerRow)
      
      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      
      // 导出文件
      XLSX.writeFile(wb, fileName)
    },
    // 格式化金额显示
    formatMoneyValue(value) {
      if (value != null && value !== "") {
        return formatMoneyUtil(value, '');
      }
      return "0.00";
    },
    
    // 格式化日期显示
    formatDateValue(value) {
      if (value && new Date(value).getFullYear() !== 1) {
        return formatDateUtil(value, 'YYYY-MM-DD HH:mm:ss');
      }
      return "";
    },
    
    // 判断是否为图片文件
    isImageFile(url) {
      if (!url) return false;
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
      return imageExtensions.some(ext => url.toLowerCase().includes(ext));
    },
    getFileUrl(file) {
      if (typeof file === 'string') return file
      return file && (file.url || file.path) ? (file.url || file.path) : ''
    },
    getFileName(file, index) {
      if (file && typeof file === 'object' && file.name) return file.name
      const url = this.getFileUrl(file)
      if (!url) return `保单文件${index + 1}`
      const name = url.split('?')[0].split('/').pop()
      try {
        return decodeURIComponent(name) || `保单文件${index + 1}`
      } catch (error) {
        return name || `保单文件${index + 1}`
      }
    },
    viewFile(file) {
      const url = this.getFileUrl(file)
      if (!url) {
        this.$message.warning('保单文件地址不存在')
        return
      }
      window.open(url, '_blank', 'noopener')
    },
    downloadFile(file, index) {
      const url = this.getFileUrl(file)
      if (!url) {
        this.$message.warning('保单文件地址不存在')
        return
      }
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.rel = 'noopener'
      link.download = this.getFileName(file, index)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    
    // 格式化是否关闭加人
    formatCloseAdd(row, column, cellValue) {
      return cellValue ? "是" : "否";
    },
    

    
    // 格式化工作类型
    formatWorkType(cellValue) {
      const typeMap = {
        "1": "搬运工人",
        "2": "文员内勤",
        "4": "司机押运"
      };
      return typeMap[cellValue] || "";
    },
    
    // 格式化员工单价
    formatEmployeePrice(employee, formData) {
      if (employee.type == 1) {
        return this.formatMoneyValue(formData.driver_price);
      } else if (employee.type == 2) {
        return this.formatMoneyValue(formData.clerk_price);
      } else if (employee.type == 4) {
        return this.formatMoneyValue(formData.trucker_price);
      }
      return "0.00";
    },
    
    // 格式化投保类型
    formatInsureType(row, column, cellValue) {
      const typeMap = {
        "1": "客户投保",
        "2": "代客投保",
        "4": "线下投保"
      };
      return typeMap[cellValue] || "";
    },
    
    // 格式化来源
    formatSource(cellValue) {
      const sourceMap = {
        "1": "PC",
        "2": "Mobile",
        "4": "iOS",
        "8": "Android",
        "16": "API"
      };
      return sourceMap[cellValue] || "";
    },
    
    // 格式化结算渠道
    formatSettlementChannel(row, column, cellValue) {
      const channelMap = {
        "1": "恒丰经纪",
        "2": "中际心元",
        "4": "鼎盛",
        "16": "现金结算",
        "32": "北京丰融",
        "17": "四川人保-物流保险网",
        "18": "金联安"
      };
      return channelMap[cellValue] || "未知";
    },
    
    // 格式化审核状态
    formatCheckedStatus(row, column, cellValue) {
      return cellValue ? "已审核" : "未审核";
    },
    
    // 格式化发票状态
    formatInvoiceReceived(row, column, cellValue) {
      return cellValue ? "已收到" : "未收到";
    },
    
    // 格式化开票类型
    formatVatInvoiceType(rowData) {
      // 根据vat_invoice_open_type和vat_invoice_type来确定显示内容
      if (rowData.vat_invoice_open_type == 1) {
        if (rowData.vat_invoice_type == 1) {
          return "普票";
        } else if (rowData.vat_invoice_type == 2) {
          return "专票";
        }
      } else if (rowData.vat_invoice_open_type == 2) {
        return "不开票";
      } else {
        return "待定";
      }
      return "";
    },
    
    // 格式化发票开具类型
    formatVatInvoiceOpenType(cellValue) {
      const openTypeMap = {
        "1": "开票",
        "2": "不开票",
        "4": "待定"
      };
      return openTypeMap[cellValue] || "";
    },
    
    // 格式化开票类型详情
    formatVatInvoiceTypeDetail(cellValue) {
      const typeMap = {
        "1": "普票",
        "2": "专票"
      };
      return typeMap[cellValue] || "";
    },
    
    // 格式化开票抬头
    formatVatInvoiceTitle(cellValue) {
      const titleMap = {
        "1": "企业",
        "2": "个人"
      };
      return titleMap[cellValue] || "";
    },
    
    // 格式化订单渠道
    formatPolicyChannel(rowData) {
      // 使用channelMap来映射渠道商ID到名称
      if (rowData.channel_id && this.channelMap[rowData.channel_id]) {
        return this.channelMap[rowData.channel_id];
      }
      
      // 如果在channelMap中找不到，尝试使用rowData中的realname或alias
      if (rowData.realname && rowData.alias) {
        return `${rowData.realname}(${rowData.alias})`;
      } else if (rowData.realname) {
        return rowData.realname;
      } else if (rowData.alias) {
        return rowData.alias;
      }
      
      // 如果找不到对应的名称，使用原来的逻辑
      if (rowData.policy_channel != "" && rowData.alias) {
        return rowData.policy_channel + "(" + rowData.alias + ")";
      } else if (rowData.alias) {
        return rowData.alias;
      }
      return rowData.policy_channel || "";
    },
    
    // 格式化保险公司
    formatInsuranceType(cellValue) {
      if (!cellValue) return "";
      
      // 从保险公司选项中查找对应的名称
      const insurance = this.insuranceOptions.find(item => 
        item.id == cellValue || String(item.id) === String(cellValue)
      );
      
      if (insurance) {
        return insurance.name;
      }
      
      // 如果在选项中找不到，返回原值
      return cellValue;
    },
    
    // 格式化保单信息回传
    formatPolicyNotify(rowData) {
      // 如果有保单号
      if (rowData.policy_no) {
        if (rowData.policy_notify_success) {
          return "已回传";
        } else {
          return "手动回传";
        }
      } else {
        return "-";
      }
    },
    
    // 文件上传成功处理方法
    handleLicenseFileSuccess(response, file, fileList) {
      console.log('license文件上传成功:', response);
      if (response && response.err_code === 0 && response.data) {
        this.formData.license_file_url = response.data;
        console.log('license_file_url已设置:', response.data);
      } else {
        console.log('license文件上传响应异常:', response);
      }
      this.fileList.licenseFileList = fileList;
    },
    
    handleLicenseFileRemove(file, fileList) {
      this.formData.license_file_url = '';
      this.fileList.licenseFileList = fileList;
    },
    
    handleTaxFileSuccess(response, file, fileList) {
      if (response && response.err_code === 0 && response.data) {
        this.formData.tax_file_url = response.data;
      }
      this.fileList.taxFileList = fileList;
    },
    
    handleTaxFileRemove(file, fileList) {
      this.formData.tax_file_url = '';
      this.fileList.taxFileList = fileList;
    },
    
    handleVatFileSuccess(response, file, fileList) {
      if (response && response.err_code === 0 && response.data) {
        this.formData.vat_file_url = response.data;
      }
      this.fileList.vatFileList = fileList;
    },
    
    handleVatFileRemove(file, fileList) {
      this.formData.vat_file_url = '';
      this.fileList.vatFileList = fileList;
    },
    
    handlePolicyFileSuccess(response, file, fileList) {
      if (response && response.err_code === 0 && response.data) {
        if (!this.formData.policy_file) {
          this.$set(this.formData, 'policy_file', []);
        }
        this.formData.policy_file.push({
          filename: file.name,
          url: response.data
        });
      }
      this.fileList.policyFileList = fileList;
    },
    
    handlePolicyFileRemove(file, fileList) {
      if (this.formData.policy_file) {
        const index = this.formData.policy_file.findIndex(item => item.url === file.url);
        if (index > -1) {
          this.formData.policy_file.splice(index, 1);
        }
      }
      this.fileList.policyFileList = fileList;
    },
    
    handleProposalFileSuccess(response, file, fileList) {
      if (response && response.err_code === 0 && response.data) {
        if (!this.formData.proposal_url) {
          this.$set(this.formData, 'proposal_url', []);
        }
        this.formData.proposal_url.push(response.data);
      }
      this.fileList.proposalFileList = fileList;
    },
    
    handleProposalFileRemove(file, fileList) {
      if (this.formData.proposal_url) {
        const index = this.formData.proposal_url.indexOf(file.url);
        if (index > -1) {
          this.formData.proposal_url.splice(index, 1);
        }
      }
      this.fileList.proposalFileList = fileList;
    },
    

    
    beforeEmployeeExcelUpload(file) {
      const extension = String(file.name || '').split('.').pop().toLowerCase()
      const valid = extension === 'xls' || extension === 'xlsx'
      if (!valid) {
        this.$message.error('员工信息仅支持 xls、xlsx 文件')
        return false
      }

      // 必须在上传前读取原始 File。上传完成回调中的 file.raw 在部分浏览器和
      // Element Upload 状态切换后可能已不可用，导致有效的旧版 xls 被误判为损坏。
      return this.parseEmployeeExcel(file).then(employeeList => {
        this.pendingEmployeeImport = {
          uid: file.uid,
          name: file.name,
          employeeList
        }
        return true
      }).catch(error => {
        this.pendingEmployeeImport = null
        this.$message.error(error.message || '员工信息 Excel 解析失败')
        return Promise.reject(error)
      })
    },

    async handleExcelFileSuccess(response, file, fileList) {
      if (!response || response.err_code !== 0 || !response.data) {
        this.clearEmployeeExcelFile()
        this.$message.error((response && response.err_msg) || '员工信息文件上传失败')
        return
      }

      try {
        const pendingImport = this.pendingEmployeeImport
        if (!pendingImport || pendingImport.uid !== file.uid) {
          throw new Error('员工信息文件解析结果已失效，请重新选择文件')
        }
        const employeeList = pendingImport.employeeList
        this.$set(this.formData, 'employee_list', employeeList)
        this.$set(this.formData, 'excel_file_url', response.data)
        file.url = response.data
        this.fileList.excelFileList = fileList
        this.pendingEmployeeImport = null
        this.$message.success(`成功导入 ${employeeList.length} 条员工信息`)
      } catch (error) {
        this.clearEmployeeExcelFile()
        this.$message.error(error.message || '员工信息 Excel 解析失败')
      }
    },
    
    handleExcelFileRemove(file, fileList) {
      this.formData.excel_file_url = '';
      this.fileList.excelFileList = fileList;
      this.pendingEmployeeImport = null
    },

    clearEmployeeExcelFile() {
      this.$set(this.formData, 'excel_file_url', '')
      this.fileList.excelFileList = []
      this.pendingEmployeeImport = null
      this.$nextTick(() => {
        if (this.$refs.excelUpload) this.$refs.excelUpload.clearFiles()
      })
    },

    readEmployeeExcelFile(file) {
      return new Promise((resolve, reject) => {
        if (!file) {
          reject(new Error('未读取到员工信息文件，请重新上传'))
          return
        }
        const reader = new FileReader()
        reader.onload = event => resolve(event.target.result)
        reader.onerror = () => reject(new Error('员工信息文件读取失败，请重新上传'))
        reader.readAsArrayBuffer(file)
      })
    },

    loadEmployeeExcelParser() {
      if (
        window.XLSX &&
        window.XLSX.version === '0.18.12' &&
        window.XLSX.__employeeParserIsolated
      ) {
        return Promise.resolve(window.XLSX)
      }
      if (this.employeeExcelParserPromise) return this.employeeExcelParserPromise

      this.employeeExcelParserPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        const baseUrl = (process.env.BASE_URL || '/').replace(/\/?$/, '/')
        const hasGlobalCodepage = Object.prototype.hasOwnProperty.call(window, 'cptable')
        const globalCodepage = window.cptable
        const restoreGlobalCodepage = () => {
          if (hasGlobalCodepage) {
            window.cptable = globalCodepage
          } else {
            delete window.cptable
          }
        }

        // manage 中 npm xlsx 注入的 cptable 与旧项目浏览器版解析器不兼容。
        // 加载时临时隔离该全局变量，使 0.18.12 使用自身的浏览器解码逻辑。
        try {
          delete window.cptable
        } catch (error) {
          window.cptable = undefined
        }
        script.src = `${baseUrl}static/xlsx-legacy-0.18.12.js`
        script.async = true
        script.onload = () => {
          restoreGlobalCodepage()
          if (window.XLSX && window.XLSX.read && window.XLSX.utils) {
            window.XLSX.__employeeParserIsolated = true
            resolve(window.XLSX)
          } else {
            reject(new Error('Excel 解析组件初始化失败'))
          }
        }
        script.onerror = () => {
          restoreGlobalCodepage()
          reject(new Error('Excel 解析组件加载失败，请刷新页面后重试'))
        }
        document.head.appendChild(script)
      }).catch(error => {
        this.employeeExcelParserPromise = null
        throw error
      })

      return this.employeeExcelParserPromise
    },

    async parseEmployeeExcel(file) {
      const arrayBuffer = await this.readEmployeeExcelFile(file)
      const excelParser = await this.loadEmployeeExcelParser()
      let workbook
      try {
        workbook = excelParser.read(arrayBuffer, { type: 'array' })
      } catch (arrayError) {
        try {
          const base64 = this.arrayBufferToBase64(arrayBuffer)
          workbook = excelParser.read(base64, { type: 'base64' })
        } catch (base64Error) {
          console.error('员工信息 Excel 解析失败:', {
            arrayError,
            base64Error,
            fileName: file && file.name,
            fileSize: file && file.size,
            parserVersion: excelParser.version
          })
          const reason = base64Error && base64Error.message
            ? base64Error.message
            : (arrayError && arrayError.message ? arrayError.message : '未知原因')
          throw new Error(`Excel 文件解析失败：${reason}`)
        }
      }

      const records = []
      workbook.SheetNames.forEach(sheetName => {
        const rows = excelParser.utils.sheet_to_json(workbook.Sheets[sheetName], {
          defval: '',
          raw: false
        })
        rows.forEach((row, index) => {
          records.push({ row, sheetName, rowNumber: index + 2 })
        })
      })

      const workTypeMap = {
        搬运工人: 1,
        文员内勤: 2,
        司机押运: 4
      }
      const employeeList = []

      records.forEach(record => {
        const normalized = {}
        Object.keys(record.row).forEach(key => {
          normalized[String(key).replace(/\s+/g, '')] = record.row[key]
        })

        const nameValue = normalized['姓名']
        const idcardValue = normalized['身份证号'] !== undefined
          ? normalized['身份证号']
          : normalized['身份证号码']
        const workTypeValue = normalized['工作类型'] !== undefined
          ? normalized['工作类型']
          : normalized['工种类别']
        const name = String(nameValue == null ? '' : nameValue).replace(/\s+/g, '')
        const idcard = String(idcardValue == null ? '' : idcardValue).replace(/\s+/g, '')
        const workTypeName = String(workTypeValue == null ? '' : workTypeValue).trim()

        if (!name && !idcard && !workTypeName) return
        const location = `${record.sheetName} 第 ${record.rowNumber} 行`
        if (!name) throw new Error(`${location}缺少姓名`)
        if (!idcard) throw new Error(`${location}缺少身份证号`)
        if (!workTypeMap[workTypeName]) {
          throw new Error(`${location}工作类型应为搬运工人、文员内勤或司机押运`)
        }

        employeeList.push({
          name,
          idcard,
          type: workTypeMap[workTypeName],
          is_highlight: false
        })
      })

      if (!employeeList.length) {
        throw new Error('Excel 中没有可导入的员工信息，请使用员工信息模板填写')
      }
      return employeeList
    },

    arrayBufferToBase64(arrayBuffer) {
      const bytes = new Uint8Array(arrayBuffer)
      const chunkSize = 10240
      let binary = ''
      for (let offset = 0; offset < bytes.length; offset += chunkSize) {
        binary += String.fromCharCode.apply(
          null,
          bytes.subarray(offset, Math.min(offset + chunkSize, bytes.length))
        )
      }
      return window.btoa(binary)
    },
    
    // 获取省份选项
    getProvinceOptions(query) {
      // 调用API获取省份列表
      getProvinceList().then(response => {
        console.log('省份列表API响应:', response);
        
        if (response && response.err_code === 0 && response.rows) {
          let provinces = response.rows;
          
          // 如果有搜索关键词，进行过滤
          if (query) {
            provinces = provinces.filter(province => 
              province.includes(query)
            );
          }
          
          // 转换为选项格式
          this.provinceOptions = provinces.map(province => ({
            value: province.province,
            label: province.province
          }));
        } else {
          console.error('获取省份列表失败:', response);
          this.provinceOptions = [];
        }
      }).catch(error => {
        console.error('获取省份列表API调用失败:', error);
        this.provinceOptions = [];
      });
    },
    
    // 获取城市选项
    getCityOptions(query) {
      // 根据选择的省份获取城市列表
      const selectedProvince = this.formData.province;
      
      if (!selectedProvince) {
        console.log('未选择省份，无法获取城市列表');
        this.cityOptions = [];
        return;
      }
      
      // 调用API获取城市列表
      const params = {
        province: selectedProvince
      };
      
      getCityList(params).then(response => {
        console.log('城市列表API响应:', response);
        
        if (response && response.err_code === 0 && response.data) {
          let cities = response.data;
          
          // 如果有搜索关键词，进行过滤
          if (query) {
            cities = cities.filter(city => 
              city.includes(query)
            );
          }
          
          // 转换为选项格式
          this.cityOptions = cities.map(city => ({
            value: city.city,
            label: city.city
          }));
        } else {
          console.error('获取城市列表失败:', response);
          this.cityOptions = [];
        }
      }).catch(error => {
        console.error('获取城市列表API调用失败:', error);
        this.cityOptions = [];
      });
    },
    
    // 下载员工信息模板
    downloadEmployeeTemplate() {
      console.log('下载员工信息模板');
      // 这里可以添加下载统计或其他逻辑
      // 实际下载由href属性处理
    }
  }
}
</script>

<style lang="less" scoped>
.employee-section-header {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  column-gap: 20px;
  margin: 15px 0 12px;
}

.employee-section-title {
  grid-column: 2;
  margin: 7px 0 0;
  text-align: center;
  white-space: nowrap;
}

.employee-excel-panel {
  grid-column: 3;
  justify-self: end;
  min-width: 400px;
  font-size: 14px;
}

.employee-excel-upload-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 10px;
}

.employee-excel-label {
  line-height: 32px;
  white-space: nowrap;
}

.employee-excel-upload {
  min-width: 100px;
}

.employee-template-link {
  color: brown;
  line-height: 32px;
  text-decoration: none;
  white-space: nowrap;
}

.employee-excel-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
}

.employee-table-container {
  overflow-x: auto;
}

.employee-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.employee-table th,
.employee-table td {
  padding: 8px;
  text-align: center;
  border: 1px solid #ddd;
}

.employee-table th {
  background-color: #f5f7fa;
  font-weight: bold;
}

.easyui-tooltip {
  cursor: help;
  border-bottom: 1px dotted #000;
}
</style>
